import React from 'react'
import classNames from 'classnames'
import { NotePencil, Trash } from '@phosphor-icons/react'

export default function SimpleField({
    children,
    label,
    onClick,
    deleteAction,
    className = ""
}) {

    let classes = typeof className === "string" ? className.split(" ").reduce((acc, item) => {
        acc[item] = true
        return acc
    }, {}) : className;

    const Classes = classNames({
        "block": true,
        ...classes
    })

    return (
        <div className={Classes}>
            {label &&
                <div className='text-gray text-sm'>{label}</div>
            }

            <div className='flex items-center'>
                {children}

                <div className='flex'>
                    {onClick &&
                        <NotePencil
                            className='w-5 h-5 ml-2 hover:fill-primary cursor-pointer'
                            onClick={() => onClick()}
                        />
                    }
                    {deleteAction &&
                        <Trash
                            className='w-4 h-4 ml-2 hover:fill-red cursor-pointer'
                            onClick={() => deleteAction()}
                        />
                    }
                </div>
            </div>
        </div>
    )
}
